import { useEffect } from 'react'

export const ScrollToTop = () => {
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 100)
        // eslint-disable-next-line react-hooks/exhaustive-deps, no-restricted-globals -- We want to retrigger this on pathname changes
    }, [location.pathname])

    return null
}
